

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { SectionsContext } from '../../context/section/SectionContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';




export const SectionPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { addSection, updateSection } = useContext(SectionsContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');

    var section;

    if (state) {
        section = state.section;
    } else {
        section = {
            id: -1,
            name: '',
            description: '',
            status: ''
        }
    }


    const { formState, onInputChange } = useForm(section);

    const { id, name, description, status } = formState

    /*useEffect(() => {
        const formValid = name.length > 0 && status.length > 0
        setIsFormValid(formValid);
    }, [name, status])*/



    const handleSave = async () => {

        const formValid = name.length > 0 && status != -1
        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos");
            return false;
        }

        var resp = "";
        if (id > 0) {
            resp = await updateSection(formState);
        } else {
            resp = await addSection(formState);
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Sección actualizada correctamente" : "Sección creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{id > 0 ? 'Actualizar sección' : 'Crear sección'}</h3>
                <hr />

                <form className="row g-3 " >



                    <div className="mb-3">
                        <label htmlFor="sectionNameInput" className="form-label">Nombre *</label>
                        <input
                            id='sectionNameInput'
                            type="text"
                            className={`form-control${required.mark(!name)}`}
                            placeholder="Nombre"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="descriptionInput" className="form-label">Descripción</label>
                        <input
                            id='descriptionInput'
                            type="text"
                            className="form-control"
                            placeholder="Descripción"
                            name="description"
                            value={description}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3 ">
                        <label htmlFor="statusSelect" className="form-label">Estado *</label>
                        <select id='statusSelect' className={`form-select${required.mark(status == -1)}`} name='status' value={status} onChange={onInputChange} >
                            <option key={-1} value={-1} >Seleccione una opción</option>
                            <option key={0} value={'ACT'} >Activa</option>
                            <option key={0} value={'INA'} >Inactiva</option>

                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>



                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
